import { getCalendarByCalendarId } from '../selectors/calendarsCacheSelectors';
import Calendar from '../store/schema/Calendar';

export default function getNonNullCalendarsFromCalendarIds(calendarIds: string[]): Calendar[] {
    return calendarIds
        ? calendarIds.map(getCalendarByCalendarId).filter(calendar => !!calendar) // Make sure we remove null calendars (this happens when cache is not loaded or when the group calendars have not loaded to the cache and we don't get calendar objects from the cache)
        : null;
}
